import React, { useMemo, useState } from 'react';
import { Search } from 'lucide-react';

const faqItems = [
  {
    question: 'How early should I arrive on race day?',
    answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer consequat, sapien sed convallis luctus, libero magna fermentum velit, vitae commodo mauris magna non nunc.',
  },
  {
    question: 'Where can I collect my race bib?',
    answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque in arcu et lectus commodo ultricies. Suspendisse a enim quis neque tincidunt vulputate.',
  },
  {
    question: 'Is there parking near the start line?',
    answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi id urna vitae est placerat volutpat. In ac tortor congue, congue nibh a, vestibulum turpis.',
  },
  {
    question: 'Can I transfer my entry to another runner?',
    answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper, orci et congue hendrerit, ipsum nunc posuere nibh, sit amet feugiat mi lacus id justo.',
  },
  {
    question: 'What support stations are available on course?',
    answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus tincidunt nibh nec ipsum efficitur, non gravida erat consequat. Aliquam ut dapibus nibh.',
  },
  {
    question: 'What happens if weather conditions change?',
    answer: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed a aliquet mi. Aenean non malesuada justo, at condimentum dolor. Vestibulum ante ipsum primis in faucibus.',
  },
];

export const FaqPage = () => {
  const [query, setQuery] = useState('');

  const filteredItems = useMemo(() => {
    const normalised = query.trim().toLowerCase();
    if (!normalised) return faqItems;

    return faqItems.filter((item) =>
      item.question.toLowerCase().includes(normalised) ||
      item.answer.toLowerCase().includes(normalised)
    );
  }, [query]);

  return (
    <>
      <section className="relative min-h-[45vh] sm:min-h-[50vh] flex items-end section-full overflow-hidden">
        <div
          className="absolute inset-0 z-0 md:hidden"
          style={{
            backgroundImage: 'url(/hero-camden-dawn.webp)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
        </div>
        <div
          className="absolute inset-0 z-0 hidden md:block"
          style={{
            backgroundImage: 'url(/hero-camden-scenic-desktop.webp)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
        </div>

        <div className="container-wide relative z-10 pb-12 sm:pb-16">
          <p className="text-white/80 text-sm uppercase tracking-widest font-bold mb-3">Support</p>
          <h1 className="display-title text-5xl sm:text-6xl md:text-7xl text-white mb-3">
            FAQ
          </h1>
          <p className="text-white/85 text-base sm:text-lg max-w-2xl">
            Common questions about race weekend, registrations, and event logistics.
          </p>
        </div>
      </section>

      <section id="faq" className="section-full bg-muted py-16 sm:py-20 lg:py-24 border-t border-border">
        <div className="container-wide">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-foreground mb-6 sm:mb-8" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Frequently asked questions
            </h2>
            <div className="relative mb-8">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground" size={20} />
              <input
                type="search"
                placeholder="Search FAQs..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="w-full h-14 pl-12 pr-4 border-2 border-primary bg-white text-foreground placeholder:text-muted-foreground shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
              />
            </div>

            <div className="text-sm text-muted-foreground mb-6">
              {filteredItems.length} result{filteredItems.length === 1 ? '' : 's'}
            </div>

            <div className="space-y-4">
              {filteredItems.map((item, index) => (
                <details key={`${item.question}-${index}`} className="bg-white border border-border p-5">
                  <summary className="font-black text-lg cursor-pointer" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                    {item.question}
                  </summary>
                  <p className="text-muted-foreground mt-4 leading-relaxed">
                    {item.answer}
                  </p>
                </details>
              ))}
              {filteredItems.length === 0 && (
                <div className="bg-white border border-border p-6 text-muted-foreground">
                  No results for "{query}". Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FaqPage;
